/*!

=========================================================
* Vision UI Free Chakra - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-chakra
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-chakra/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import {
  Avatar,
  AvatarGroup,
  Button,
  Flex,
  Icon,
  Progress,
  Td,
  Text,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";

function DashboardTableRow(props) {
  const { packagePR, clientName, campaignName, date, lastItem } = props;
  const textColor = useColorModeValue("gray.700", "white");
  return (
    <Tr>
      <Td
        ps='0px'
        borderBottomColor='#56577A'
        border={lastItem ? "none" : null}
      >
        <Text fontSize='sm' color='#fff' fontWeight='bold' pb='.5rem'>
          {date}
        </Text>
      </Td>
      <Td
        minWidth={{ sm: "200px" }}
        borderBottomColor='#56577A'
        border={lastItem ? "none" : null}
      >
        <Text fontSize='sm' color='#fff' fontWeight='normal' minWidth='100%'>
          {campaignName}
        </Text>
      </Td>
      <Td
        minWidth={{ sm: "200px" }}
        borderBottomColor='#56577A'
        border={lastItem ? "none" : null}
      >
        <Text fontSize='sm' color='#fff' fontWeight='normal' minWidth='100%'>
          {clientName}
        </Text>
      </Td>

      <Td borderBottomColor='#56577A' border={lastItem ? "none" : null}>
        <Text fontSize='sm' color='#fff' fontWeight='bold' pb='.5rem'>
          {packagePR}
        </Text>
      </Td>
      <Td border={lastItem ? "none" : null} borderBottomColor='#56577A'>
        <Button
          p='2px 10px'
          bg='brand.20'
          borderRadius='4px'
          // border="1px solid #fff"
          variant='no-hover'
        >
          <Text
            fontSize='sm'
            color='#fff'
            fontWeight='bold'
            cursor='pointer'
            _hover={{ backgroundColor: "brand.200" }}
          >
            More
          </Text>
        </Button>
      </Td>
    </Tr>
  );
}

export default DashboardTableRow;
